<template>
<Panel :header="faqInfo.title" :toggleable="true" collapsed class="spaced">
    {{faqInfo.content}}
</Panel>
</template>
<script>
export default {
    props:{
        faqInfo:null,
    }
    
}
</script>
<style scoped>
    .spaced{
        margin-bottom: 1rem;
    }
    
</style>